<template>
	<div class="main-header align-c minwidth">
		<div class="mx1360 align-c between">
			<div @click="goPage('/index')" class="logo align-c">
				<img src="@/static/z-icon-logo.png" class="p" />
				<div class="k">
					<div class="t">环太湖艺术动产</div>
					<div class="t2">登记备案综合服务平台</div>
					<div class="t3">Huantaihu Art Asset Registry Platform</div>
				</div>
			</div>
			<div class="rightbox align-c">
				<ul class="menu2 align-c">
					<li @click="goPage('/userCenter/index')" class="cur curadm" :class="name=='主页'?'on':''">主页</li>
					<li @click="goPage('/userCenter/workRegistration')" class="cur curadm" :class="name=='作品登记'?'on':''">作品登记</li>
				</ul>
				<i class="el-icon-menu btn-menu cur curadm"></i>
				<!-- <div class="user align-c">
					<div class="login-btn">登录</div>
					<div class="register-btn vcenter">免费注册</div>
				</div> -->
			</div>

		</div>
		<login ref="login" @loginok="loginok" @regok="regok"></login>
		<tooltips ref="tooltips" @topersonal="topersonal"></tooltips>
		<personal ref="personal"></personal>
	</div>
</template>

<script>
import util from "@/common/util.js";
import login from "@/components/login/login"
import tooltips from "@/components/tooltips/tooltips"
import personal from "@/components/personal/personal"
export default {
	name: 'myheader2',
	components:{
		login,
		tooltips,
		personal
	},
	props: {
		//外部参数示例
		name: {
		    type: String,
		    default: ""
		},
	},
	data() {
		return {
			// 内部参数
			islogin:false,
			username:"",
		}
	},
	methods: {
		goPage(path) {
			util.tourl(path)
		},
		tologin(){
			this.$refs.login.type=1
			this.$store.commit("openlogin")
		},
		toregister(){
			this.$refs.login.type=2
			this.$store.commit("openlogin")
		},
		loginok(e){
			this.islogin = true
			var userinfo = e
			this.username = userinfo.mobile
			//this.$refs.tooltips.dialogVisible = true
		},
		regok(e){
			this.islogin = true
			var userinfo = e
			this.username = userinfo.mobile
			this.$refs.tooltips.dialogVisible = true
		},
		topersonal(){
			this.$refs.personal.dialogVisible = true
		},
		loginout(){
			this.$store.commit("logout")
			this.islogin = false
		},
	},
	mounted() {
		var token = this.$store.state.token
		var userinfo = this.$store.state.userInfo
		if (token){
			this.islogin = true
			this.username = userinfo.mobile
		}
	}

}
</script>

<style lang="scss" scoped>
@import "./header.scss";
</style>